import { headers } from "../utils/utils";

const useContenidoStore =  defineStore('contenido',() => {

  const contenido = ref({
    id: null,
    titulo: null,
    sub_titulo: null,
    orden: null,
    contenido: null,
    terminado: false,
    seccion_id: null,
    indice_id: null,
    nro_pag: 0,
    nro_paginas: 0,
    seccion: null,
    indice: null,
    notas: "",
    publicado: false,
    paginas_capitulo: null,
    pdf_url: null,
    anexos: [],
    tipo_dato: 1, // 1: texto, 2: imagen
  });


  const contenidos = ref([]);


  // getters
  const draft = computed(() => clone(contenido.value));

  // mutations

  const setContenido = (data) => {
    
    if(data){
      contenido.value = data;
    }

  }

  const clear = () => {
    contenido.value = {
      id: null,
      titulo: null,
      sub_titulo: null,
      orden: null,
      contenido: null,
      terminado: false,
      seccion_id: null,
      indice_id: null,
      nro_pag: null,
      nro_paginas: 0,
      seccion: null,
      indice: null,
      notas: "",
      publicado: false,
      pdf_url: null,
      paginas_capitulo: null,
      anexos:[],
      tipo_dato: 1, // 1: texto, 2: imagen
    };
  }

  const setContenidos = (data) => {
    if(data){
      contenidos.value = data;
    }
  } 


  const publicar = (cont) => {
    if(cont && cont.id == contenido.value.id){
      contenido.value.publicado = true;
    }
  }

  const updateContenido = (cont) => {
    if(cont && cont.id == contenido.value.id){
      contenido.value.contenido = cont;
    }

    if(contenidos.value.length){
      let i = contenidos.value.findIndex(c => c.id === cont.id);
      if(i !== -1) {
        contenidos.value[i] = {
          ...contenidos.value[i],
          ...cont
        };
      }
    }
  }


  // actions

  const addContenido = (data)  => {
    return new Promise((resolve, reject) => {
      
      axios.post(`/api/contenidos`,data)
      .then(({data}) => {
        if(data.result) setContenido(data.contenido);
        resolve(data);

      }).catch(e => reject(e));

    })
  };
  
  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      
      if(datos.id){
      
        axios.put(`/api/contenidos/${datos.id}`,datos)
        .then(({data}) => {
          if(data.result) setContenido(data.contenido);
          resolve(data);
        }).catch(e => reject(e));
      
      }else{
      
        axios.post(`/api/contenidos`,datos)
        .then(({data}) => {
          if(data.result) setContenido(data.contenido);
          resolve(data);

        }).catch(e => reject(e));

      }

    })
  };


  const eliminar = (contenido_id) => {
    return new Promise((resolve, reject) => {
      
      axios.delete(`/api/contenidos/${contenido_id}`)
      .then(({data}) => {
        resolve(data);
      })
      .catch(e => reject(e));

    })
  };

  const fetch = ( cont_id) => {
    return new Promise((resolve, reject) => {
      axios.get(`/api/contenidos/${cont_id}/fetch-data`)
      .then(({data}) => {
        if(data) setContenido(data);

        resolve(data)
      }).catch(e => {
        
        reject(e);

      })
    })
  };

  const generarContenido = (cont_id, { instruccion, msjs,paginas_cap}) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/contenidos/${cont_id}/generar-contenido`, {
          msjs: msjs.length ? msjs : null,
          instruccion: instruccion,
          paginas_cap
        })
        .then(({ data }) => resolve(data))
        .catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  };


  const aplicarContenidoGenerado = (c_id,datos) => {
    return new Promise((resolve, reject) => {
      
      axios.put(`/api/contenidos/${c_id}/aplicar-contenido-generado`, datos)
      .then(({data}) => {
        if(data.result) setContenido(data.contenido);
        resolve(data);
      }).catch(e => reject(e));

    })
  };


  const getImagenesSeccion  = (contenido_id) => {
    return new Promise((resolve, reject) => {

      axios.post(`/api/contenidos/${contenido_id}/imagenes-seccion/fetch-data`)
      .then(({data}) => {
        resolve(data);
      }).catch(e => reject(e));

    })
  };

  const eliminarSeccionImagen = (anexo_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/anexos/${anexo_id}`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  }; 


  const obtenerMensajes = (cont_id) => {
    
    return new Promise((resolve,reject) => {
      axios.get(`/api/contenidos/${cont_id}/fetch-mensajes`)
      .then(({data}) => {
        resolve(data)
      }).catch(e => {
        reject(e);
      });
    });

  };

  const actualizarNroPaginas = (cont_id, pags) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/contenidos/${cont_id}/actualizar-nro-paginas`, {
          paginas: pags,
        })
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  };


  const actualizarContenido = (cont_id,content) => {
    return new Promise((resolve, reject) => {
      axios.put(`/api/contenidos/${cont_id}/actualizar-contenido`,{contenido:content})
      .then(({data}) => {
        resolve(data)
      }).catch(e => reject(e))
      
    }) 
  }

  const actualizarDocumento = (cont_id, content) => {

    return new Promise((resolve, reject) => {
      axios.put(`/api/contenidos/${cont_id}/actualizar-documento`,{documento:content})
      .then(({data}) => {
        resolve(data)
      }).catch(e => reject(e))
      
    })
  }

  const obtenerContenidoGenerado = (c_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/contenidos/${c_id}/obtener-contenido-generado`)
        .then(({ data }) => resolve(data))
        .catch((e) => reject(e));
    });
  }

  const actualizarInclusion = ({contenido_id,incluir}) => {
    return new Promise((resolve, reject) => {
      
      axios.put(`/api/contenidos/${contenido_id}/actualizar-inclusion-indice`,{incluir})
      .then(({data}) => resolve(data))
      .catch(e => reject(e));

    })
  }

  const addNotas = (contenido_id,notas) => {
    return new Promise((resolve, reject) => {
      axios.put(`/api/contenidos/${contenido_id}/actualizar-notas`,{notas})
      .then(({data}) => {
        resolve(data);
      }).catch(e => reject(e));
    });
  }

  const getDedicatoria =  (bio_id) => {

    return new Promise((resolve, reject) => {
      axios.get(`/api/contenidos/biografias/${bio_id}/get-dedicatoria`)
      .then(({data}) => {
        setContenido(data);
        resolve(data);

      }).catch(e => reject(e));
    })
  }

  const publicarContenido = (conte_id) => {
      return new Promise((resolve, reject) => {
        axios.get(`/api/contenidos/${conte_id}/publicar`)
        .then(({data}) => {
          if(data.result) publicar(data.contenido);
          resolve(data);
        }).catch(e => reject(e));
      });
  }

  const getSobreAutor  = ( bio_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/contenidos/biografias/${bio_id}/get-sobre-autor`)
        .then(({ data }) => {
          if (data.id) {
            setContenido(data);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  } 

  const getDerechosAutor = (bio_id) => {
    return new Promise((resolve,reject) => {
      axios.get(`/api/contenidos/biografias/${bio_id}/get-derechos-autor`)
      .then(({data}) => {
        if(data.id){
          setContenido(data);
        }
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
    })
  }


  const generarPaginaSobreAutor = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/api/contenidos/${contenido.value.id}/regenerar-pagina-sobre-autor`
        )
        .then(({ data }) => {
          if (data.result) {
            setContenido(data.contenido);
          }
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const limpiarContenido = async (cont_id) => {
    try {
      const {data} = await axios.get(`/api/contenidos/${cont_id}/limpiar-contenido`);
      return data;
    } catch (error) {
        throw error;
    }
  }

  const cargarImagen = async (cont_id, file) => {
    let formData = new FormData();
    formData.append('imagen', file);
    formData.append('_method', 'PUT');
    try {
      const {data} = await axios.post(`/api/imagens/upload/models/${cont_id}`, formData, {headers});
      return data;
    } catch (error) {
      console.error('Error al cargar la imagen:', error);
      throw error;
    }

  }

  const actualizarTitulosAnexos = async (titulo,sub_titulo) => {
      try {
        const {data} = await axios.put(`/api/contenidos/${contenido.value.id}/actualizar-titulos-anexos`,{titulo,sub_titulo});
        if(data.result) setContenido(data.contenido);
        return data;
      } catch (error) {
        throw error;
      }
  }  
  
  const  actualizarParamsCreditos = async (params) => {
    try {
        const {data} = await axios.put(`/api/contenidos/${contenido.value.id}/actualizar-params-creditos`,params);
        if(data.result) setContenido(data.contenido);
        return data;
    } catch (error) {
        throw error;
    }
  } 

  return {
    contenidos,
    contenido,
    draft,
    setContenido,
    setContenidos,
    eliminar,
    addContenido,
    clear,
    fetch,
    guardar,
    generarContenido,
    aplicarContenidoGenerado,
    actualizarContenido,
    getImagenesSeccion,
    eliminarSeccionImagen,
    obtenerMensajes,
    obtenerContenidoGenerado,
    actualizarNroPaginas,
    actualizarDocumento,
    actualizarInclusion,
    addNotas,
    getDedicatoria,
    publicar,
    publicarContenido,
    getSobreAutor,
    getDerechosAutor,
    generarPaginaSobreAutor,
    limpiarContenido,
    updateContenido,
    cargarImagen,
    actualizarTitulosAnexos,
    actualizarParamsCreditos,
  };

});
export default useContenidoStore;